"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OTPFunnelService = void 0;
var crypto_js_1 = __importDefault(require("crypto-js"));
var NONCE_VALID_DURATION = 30 * 60 * 1000; // 30 min
// Generate the token using the nonce and current 10-minute window.
var generateToken = function (nonce) {
    var now = Date.now();
    var timeSlice = Math.floor(now / 60000); // 1 minute slices (60000 ms)
    var sliceStart = timeSlice * 60000;
    var message = nonce + timeSlice;
    var hash = crypto_js_1.default.HmacSHA256(message, nonce).toString(crypto_js_1.default.enc.Hex);
    // Adjust length as needed (e.g., 8 or 14 characters)
    var otp = hash.substring(0, 14);
    return { otp: otp, generatedAt: sliceStart };
};
var timeLeft = function (generatedAt) {
    var expirationTime = generatedAt + NONCE_VALID_DURATION;
    var timeLeft = expirationTime - Date.now();
    return timeLeft > 0 ? timeLeft : 0;
};
var validateToken = function (generatedAt) {
    // Compute remaining time using the new logic
    var left = timeLeft(generatedAt);
    // If there's no time left, clear storage and mark token as invalid.
    if (left <= 0) {
        localStorage.removeItem('otpToken');
        localStorage.removeItem('otpTokenTimestamp');
        return false;
    }
    return true;
};
var getToken = function () {
    var urlParams = new URLSearchParams(window.location.search);
    var urlToken = urlParams.get('otptoken');
    var urlTs = urlParams.get('ts') ? Number(urlParams.get('ts')) : 0;
    return { urlToken: urlToken, urlTs: urlTs };
};
var updateToken = function () {
    var _a = getToken(), urlToken = _a.urlToken, urlTs = _a.urlTs;
    var localToken = localStorage.getItem('otpToken');
    var localTs = localStorage.getItem('otpTokenTimestamp') ? Number(localStorage.getItem('otpTokenTimestamp')) : 0;
    if (urlToken && urlTs > localTs) {
        localStorage.setItem('otpToken', urlToken);
        localStorage.setItem('otpTokenTimestamp', urlTs.toString());
        return { token: urlToken, ts: urlTs };
    }
    if (localToken) {
        return { token: localToken, ts: localTs };
    }
    return null;
};
exports.OTPFunnelService = {
    getToken: getToken,
    updateToken: updateToken,
    validateToken: validateToken,
    generateToken: generateToken,
    timeLeft: timeLeft,
};
